import {
  PriorityContainerCommon,
  PriorityNumberCommon,
} from 'src/components/atoms/Priority/Priority.styles';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  min-height: 100vh;
  min-width: 1020px;
`;

export const BodyContainer = styled.div`
  padding: 20px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
`;

export const EmptyStateWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
`;

export const TagContainer = styled.div`
  margin-bottom: 20px;
`;

export const TagsBody = styled.div`
  margin-top: 20px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  column-gap: 20px;
  position: relative;
`;

export const OderContainer = styled(PriorityContainerCommon)``;

export const OrderNumber = styled(PriorityNumberCommon)``;

export const TagTypesJoiner = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`;

export const OrderInfoContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
  position: absolute;
  top: 55px;
  z-index: 100;
`;

export const OrderInfoSubtitle = styled.h3`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 0;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const OrderInfo = styled(StyledIcon)`
  cursor: pointer;
`;

export const OrderParagraph = styled.p`
  margin: 0;
  margin-bottom: 20px;
`;

export const PageHeaderContainer = styled.div`
  position: relative;
`;
